/**
 * Converts a JSON object to Uint8Array format
 * @param {*} obj - The object to serialize
 * @returns {Uint8Array} - The serialized object as Uint8Array
 * @throws {Error} - If the object is not JSON serializable
 */
export function jsonToUint8Array(obj) {
  let jsonString;
  
  try {
    // Attempt to serialize the object
    jsonString = JSON.stringify(obj);
  } catch (error) {
    // Handle circular references and other serialization errors
    if (error instanceof TypeError) {
      throw new Error(`Object is not JSON serializable: ${error.message}`);
    }
    throw error;
  }
  
  // Check if serialization resulted in undefined
  if (jsonString === undefined) {
    throw new Error('Object is not JSON serializable: serialization returned undefined');
  }
  
  // Convert string to Uint8Array
  const encoder = new TextEncoder();
  return encoder.encode(jsonString);
}

/**
 * Converts a Uint8Array back to a JSON object
 * @param {Uint8Array} uint8Array - The Uint8Array to deserialize
 * @returns {*} - The parsed JSON object
 * @throws {Error} - If the Uint8Array doesn't contain valid JSON
 */
export function uint8ArrayToJson(uint8Array) {
  if (!(uint8Array instanceof Uint8Array)) {
    throw new Error('Input must be a Uint8Array');
  }
  
  // Convert Uint8Array to string
  const decoder = new TextDecoder();
  const jsonString = decoder.decode(uint8Array);
  
  try {
    // Parse the JSON string
    return JSON.parse(jsonString);
  } catch (error) {
    throw new Error(`Invalid JSON in Uint8Array: ${error.message}`);
  }
}

// Example: Round-trip conversion
try {
  const original = { name: "Charlie", scores: [95, 87, 92] };
  console.log("Original:", original);
  
  // Convert to Uint8Array
  const encoded = jsonToUint8Array(original);
  console.log("Encoded:", encoded);
  
  // Convert back to JSON
  const decoded = uint8ArrayToJson(encoded);
  console.log("Decoded:", decoded);
  console.log("Match:", JSON.stringify(original) === JSON.stringify(decoded));
} catch (error) {
  console.error("Error:", error.message);
}